module.exports = __webpack_public_path__ + "media/images/icons/chat-3a9f11188169d2a6083a35739e681c0c.svg";